var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_280646635340817088260952125101476107066",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_89893523364014335481718086983012982299",
    d: "M19.394.974c.368 0 .667.299.667.667v22.667c0 .368-.299.666-.667.666-.368 0-.667-.298-.667-.666v-8.666L3.17 26.013c-.92.613-2.16.364-2.774-.555-.219-.328-.335-.714-.335-1.11V3.379c0-1.104.895-2 2-2 .394 0 .78.117 1.11.336l15.556 10.372V1.641c0-.368.299-.667.667-.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64 -434) translate(48 426) translate(16 8) translate(6.606 2.675)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_192276159666683797550869368630915225343",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_89893523364014335481718086983012982299"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#hinava_random_uuid_280646635340817088260952125101476107066)",
    mask: "url(#hinava_random_uuid_192276159666683797550869368630915225343)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 549.545,
    height: 269.517,
    rx: 8,
    transform: "translate(-263.94 -153.333)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.0960311eaf2b0fadfaa334245d7ea889.svg";
export { ForwardRef as ReactComponent };